var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 7.91364C1.5 4.32402 4.40996 1.41406 7.99958 1.41406C11.5892 1.41406 14.4992 4.32402 14.4992 7.91364C14.4992 11.5033 11.5892 14.4132 7.99958 14.4132C4.40996 14.4132 1.5 11.5033 1.5 7.91364ZM7.46936 4.98809C7.76225 4.69519 8.23713 4.69519 8.53002 4.98809L10.4465 6.90461C10.7394 7.19751 10.7394 7.67238 10.4465 7.96527C10.1537 8.25817 9.67878 8.25817 9.38589 7.96527L8.74971 7.3291L8.74971 10.47C8.74971 10.8842 8.41392 11.22 7.99971 11.22C7.58549 11.22 7.24971 10.8842 7.24971 10.47L7.24971 7.32906L6.61349 7.96527C6.3206 8.25817 5.84573 8.25817 5.55283 7.96527C5.25994 7.67238 5.25994 7.19751 5.55283 6.90461L7.46936 4.98809Z",
    fill: "#0061C1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.cb5a69e236415e95fe7a8d5a2f8a5d34.svg";
export { ForwardRef as ReactComponent };